import { render } from "./FamilyPlanSelector.vue?vue&type=template&id=da85d9e2&scoped=true&ts=true"
import script from "./FamilyPlanSelector.vue?vue&type=script&lang=ts"
export * from "./FamilyPlanSelector.vue?vue&type=script&lang=ts"

import "./FamilyPlanSelector.vue?vue&type=style&index=0&id=da85d9e2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da85d9e2"]])

export default __exports__